import client from './axiosCommon';

export interface SegmentDetection {
  label: string;
  confidence: number;
  bbox: [number, number, number, number]; // x, y, w, h in 0..1
  color: string;
}

export interface SegmentResponse {
  mock: boolean;
  filename: string;
  sizeBytes: number;
  mimeType: string;
  detections: SegmentDetection[];
  summary: Record<string, number>;
}

export const segmentorApi = {
  segment: async (file: File): Promise<SegmentResponse> => {
    const fd = new FormData();
    fd.append('image', file);
    const res = await client.post<{ success: boolean; data: SegmentResponse }>(
      '/segmentor/segment',
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return res.data.data;
  },
};
